<template>
    <div
        class="col-xs-12 col-sm-6 col-md-6 col-lg-4 flip-container"
        :class="{ flip: !showFront }"
    >
        <!-- card with course informations -->
        <q-card class="flipper course-card">
            <!-- front card section -->
            <q-card-section
                class="front flex justify-between column col-auto q-pa-none"
            >
                <!-- course image -->
                <q-img :src="courseImage" spinner-color="white" :ratio="16 / 9">
                    <div
                        v-if="course.coursesOnLibrary.courses_coursetype"
                        class="course-type row items-center"
                    >
                        <!-- course type label: online or presential-->
                        <template
                            v-if="
                                course.coursesOnLibrary.courses_coursetype
                                    .slug === slugs.courseTypes.online
                            "
                        >
                            <q-icon
                                name="language"
                                class="q-mr-sm q-mt-xs"
                                size="20px"
                            ></q-icon>
                            <h6>{{ $t('general.online') }}</h6>
                        </template>
                        <template
                            v-if="
                                course.coursesOnLibrary.courses_coursetype
                                    .slug === slugs.courseTypes.onsite
                            "
                        >
                            <q-icon
                                name="business"
                                class="q-mr-sm q-mt-xs"
                                size="20px"
                            ></q-icon>
                            <h6>{{ $t('general.presential') }}</h6>
                        </template>
                        <!-- package label -->
                        <template
                            v-if="
                                course.coursesOnLibrary.courses_packagetypes &&
                                course.coursesOnLibrary.courses_packagetypes
                                    .system_slug === 'pacote'
                            "
                        >
                            <q-icon
                                name="file_copy"
                                class="q-mr-sm q-ml-md"
                            ></q-icon>
                            {{ $t('courses.packaged') }}
                        </template>
                    </div>
                </q-img>
                <div class="course-content">
                    <!-- informations container -->
                    <div class="info">
                        <router-link
                            :to="{
                                name: 'CourseDetails',
                                params: {
                                    id: course.course_id,
                                },
                            }"
                        >
                            <!-- course title -->
                            <div class="text-h6 course-title">
                                <strong>{{
                                    JSONParseTranslations(
                                        course.coursesOnLibrary.title,
                                        locale.key
                                    )
                                }}</strong>
                            </div>
                            <q-tooltip>{{
                                $t('profile.go_to_course_detail_page')
                            }}</q-tooltip>
                        </router-link>
                        <!-- view dates info button -->
                        <div v-if="userRole === 'student'">
                            <q-btn class="q-mt-md" flat @click="flipCard">{{
                                $t('actions.view_dates')
                            }}</q-btn>
                        </div>
                    </div>
                    <!-- button container -->
                    <div>
                        <!-- if user is client representant -->
                        <div v-if="userRole === 'client'">
                            <q-btn
                                class="full-width"
                                color="secondary"
                                :label="$t('actions.assign_employees')"
                                dense
                                @click="showDialog"
                            />
                            <!-- <div class="slots-avaliable q-mt-sm text-grey">
                        <strong>9/10</strong>
                    </div> -->
                        </div>
                        <!-- if user is individual student -->
                        <div v-else class="course-info-wrap">
                            <q-btn
                                v-if="
                                    course.coursesOnLibrary.courses_coursetype
                                        .slug === slugs.courseTypes.online
                                "
                                class="full-width"
                                color="primary"
                                :to="{
                                    name: 'CourseLearn',
                                    params: {
                                        id: course.course_id,
                                        lessonId: 1,
                                    },
                                }"
                            >
                                <q-icon name="school" class="q-mr-lg"> </q-icon>

                                <span>
                                    {{ $t('courses.start_lessons') }}
                                </span>
                            </q-btn>
                            <!-- <q-linear-progress
                        size="20px"
                        :value="course.progress"
                        color="primary"
                    >
                        <div class="absolute-full flex flex-center">
                            <q-badge
                                color="white"
                                text-color="black"
                                :label="progressLabel(course.progress)"
                            />
                        </div>
                    </q-linear-progress> -->
                            <q-btn
                                v-if="
                                    course.coursesOnLibrary.courses_coursetype
                                        .slug === slugs.courseTypes.onsite &&
                                    course.enrollment_id &&
                                    course.enrollment.status.slug !==
                                        slugs.enrollmentStatus.canceled
                                "
                                class="full-width"
                                color="primary"
                                :to="{
                                    name: 'CourseTimetable',
                                    params: {
                                        id: course.course_id,
                                        enrollmentId: course.enrollment_id,
                                    },
                                }"
                            >
                                <q-icon name="event" class="q-mr-lg"> </q-icon>

                                <span>
                                    {{ $t('courses.my_timetable') }}
                                </span>
                            </q-btn>
                            <q-btn
                                v-if="
                                    course.coursesOnLibrary.courses_coursetype
                                        .slug === slugs.courseTypes.onsite &&
                                    course.enrollment_id &&
                                    course.enrollment.status.slug ===
                                        slugs.enrollmentStatus.canceled
                                "
                                class="full-width"
                                color="secondary"
                                disable
                                >{{ $t('courses.enrollment_canceled') }}</q-btn
                            >
                            <q-btn
                                v-if="
                                    course.coursesOnLibrary.courses_coursetype
                                        .slug === slugs.courseTypes.onsite &&
                                    !course.enrollment_id
                                "
                                class="full-width"
                                color="secondary"
                                >{{ $t('courses.without_enrollment') }}</q-btn
                            >
                        </div>
                    </div>
                </div>
            </q-card-section>
            <!-- back card section -->
            <q-card-section
                class="back flex justify-between column col-auto q-pa-none"
            >
                <!-- course image -->
                <q-img :src="courseImage" spinner-color="white" :ratio="16 / 9">
                    <div
                        v-if="course.coursesOnLibrary.courses_coursetype"
                        class="course-type row items-center"
                    >
                        <!-- course type label: online or presential-->
                        <template
                            v-if="
                                course.coursesOnLibrary.courses_coursetype
                                    .slug === slugs.courseTypes.online
                            "
                        >
                            <q-icon
                                name="language"
                                class="q-mr-sm q-mt-xs"
                                size="20px"
                            ></q-icon>
                            <h6>{{ $t('general.online') }}</h6>
                        </template>
                        <template
                            v-if="
                                course.coursesOnLibrary.courses_coursetype
                                    .slug === slugs.courseTypes.onsite
                            "
                        >
                            <q-icon
                                name="business"
                                class="q-mr-sm q-mt-xs"
                                size="20px"
                            ></q-icon>
                            <h6>{{ $t('general.presential') }}</h6>
                        </template>
                        <!-- package label -->
                        <template
                            v-if="
                                course.coursesOnLibrary.courses_packagetypes &&
                                course.coursesOnLibrary.courses_packagetypes
                                    .system_slug === 'pacote'
                            "
                        >
                            <q-icon
                                name="file_copy"
                                class="q-mr-sm q-ml-md"
                            ></q-icon>
                            {{ $t('courses.packaged') }}
                        </template>
                    </div>
                </q-img>
                <div class="course-content">
                    <!-- informations container -->
                    <div class="info">
                        <!-- date course was added to library -->
                        <div class="text-grey-10">
                            <span
                                ><strong>{{
                                    $t('general.enrollment_date')
                                }}</strong></span
                            ><br />
                            {{ formatDate(course.created_at) }}
                        </div>
                        <!-- course class start date -->
                        <div
                            v-if="
                                course.coursesOnLibrary.courses_coursetype
                                    .slug === slugs.courseTypes.onsite
                            "
                            class="text-grey-10 q-mt-sm"
                        >
                            <span
                                ><strong>{{
                                    $t('general.start_date')
                                }}</strong></span
                            ><br />
                            {{
                                formatDate(course.enrollment.classes.start_date)
                            }}
                        </div>
                        <!-- course class end date -->
                        <div
                            v-if="
                                course.coursesOnLibrary.courses_coursetype
                                    .slug === slugs.courseTypes.onsite
                            "
                            class="text-grey-10 q-mt-sm"
                        >
                            <span
                                ><strong>{{
                                    $t('general.end_date')
                                }}</strong></span
                            ><br />
                            {{ formatDate(course.enrollment.classes.end_date) }}
                        </div>
                        <!-- view dates info button -->
                        <div v-if="userRole === 'student'">
                            <q-btn class="q-mt-md" flat @click="flipCard">{{
                                $t('actions.back')
                            }}</q-btn>
                        </div>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import picturesService from '@/services/pictures'
import formatDate from '@/helpers/date-time'
import encoders from '@/helpers/encoders'
import store from '@/store'
import { slugs } from '@/local-shared/mixins/slugs'

export default {
    name: 'CourseLibraryThumb',

    mixins: [translate],

    props: {
        course: {
            type: Object,
            default: () => {},
        },
        userRole: {
            type: String,
            default: 'student',
        },
    },

    data() {
        return {
            slugs: slugs,

            courseImage: '',

            showFront: true,
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },
    },

    async created() {
        if (this.course.coursesOnLibrary.coursepicture_id) {
            this.courseImage = await this.fetchImage(
                this.course.coursesOnLibrary.coursepicture_id
            )
        } else {
            this.courseImage = require('@/assets/logo.svg')
        }
    },

    methods: {
        flipCard() {
            this.showFront = !this.showFront
        },

        progressLabel(value) {
            return (value * 100).toFixed(2) + '%'
        },

        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        },

        showDialog() {
            this.$emit('show-dialog', this.course)
        },

        dateMaskFormat() {
            return this.locale &&
                this.locale.definition &&
                this.locale.definition.dateFormat
                ? this.locale.definition.dateFormat
                : 'DD/MM/YYYY'
        },

        formatDate(value) {
            return value
                ? formatDate.fromServerToUxString(
                      value,
                      'date',
                      this.dateMaskFormat()
                  )
                : null
        },
    },
}
</script>

<style>
/* from https://davidwalsh.name/css-flip */

/* entire container, keeps perspective */
.flip-container {
    perspective: 1000px;
    transform-style: preserve-3d;
}

/* flip the pane when icon clicked */
.flip-container.flip .flipper {
    transform: rotateY(180deg);
}

.flip-container,
.front,
.back {
    width: 100%;
    height: 100%;
}

/* flip speed goes here */
.flipper {
    transition: 0.6s;
    transform-style: preserve-3d;

    position: relative;
}

/* hide back of pane during swap */
.front,
.back {
    backface-visibility: hidden;
    transition: 0.6s;
    transform-style: preserve-3d;
    position: absolute;
    /*top: 0;*/ /* replaced by bottom because course image is on top */
    bottom: 0;
    left: 0;
}

/* front pane, placed above back */
.front {
    z-index: 2;
    /* for firefox 31 */
    transform: rotateY(0deg);
}

/* back, initially hidden pane */
.back {
    transform: rotateY(180deg);
}
</style>
